export const ultimasNoticias = [

  
  
    {
        "imagen" : "../Img/DENUNCIASEGOB.jpg",
        "url" : "",
        "titulo" : "DENUNCIA",
        "fecha" : "¿Necesitas Ayuda?"
    },

   
    {
        "imagen" : "../Img/TransparenciaenCorto2026_banner.jpg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Documentos/TRANSP%20EN%20CORTO_CONVOCATORIA_2026.pdf",
        "titulo" : "Transparencia en Corto",
        "fecha" : "Transparencia en Corto"
    },




]